import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { ENTITY_TYPES } from '@sales-center/common'
import { HeaderContainer } from './HeaderContainer'

import Typography from '@mui/material/Typography'

const styles = {
  icon: {
    margin: (theme: Theme) => `${theme.spacing(0)} ${theme.spacing(0.5)}`,
  },

  link: {
    color: '#0058a5',
    cursor: 'pointer',
  },
}

interface Props {
  entityName: string
  entityType: ENTITY_TYPES
}

export function Breadcrumbs(props: Props) {
  const { entityName, entityType } = props
  const navigate = useNavigate()
  const theme = useTheme()

  const redirectToEntityListPage = useCallback(() => {
    navigate(`/${entityType == ENTITY_TYPES.Lead ? 'leads' : 'opportunities'}`)
  }, [entityType, navigate])

  return (
    <HeaderContainer color={theme.palette.background.default} paddingY="8px">
      <Typography sx={styles.link} onClick={redirectToEntityListPage}>
        {entityType == ENTITY_TYPES.Lead ? 'Leads' : 'Opportunities'}
      </Typography>
      <Typography variant="body2" color="#32383D">
        /
      </Typography>
      <Typography variant="body2" color="#32383D">
        {entityName}
      </Typography>
      {/*<Box ml="auto!important">*/}
      {/*  <Button variant="text" color="primary">*/}
      {/*    <Typography fontWeight={500} variant="body2" color="#19305A">*/}
      {/*      Rearrange Page Layout*/}
      {/*    </Typography>*/}
      {/*  </Button>*/}
      {/*</Box>*/}
    </HeaderContainer>
  )
}
